import { render, staticRenderFns } from "./CadastrarProduto.vue?vue&type=template&id=51a4603a"
import script from "./CadastrarProduto.vue?vue&type=script&lang=js"
export * from "./CadastrarProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports